import type {UpdateOfferTemplateFormPayload} from "./update-offer-template.schema";
import {updateOfferTemplate} from "@project/sdk/sales";
import {UpdateOfferTemplateResponse} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";
import {offerTemplateKeys, offerTemplateMutationKeys} from "../../../offerTemplate-keys";
import {updateOfferTemplateFormSchema} from "./update-offer-template.schema";

export function updateOfferTemplateMutationOptions(id: string) {
  return mutationOptions({
    mutationKey: offerTemplateMutationKeys.updateOfferTemplate,
    mutationFn: async (payload: UpdateOfferTemplateFormPayload) =>
      UpdateOfferTemplateResponse.parse(
        await updateOfferTemplate(id, updateOfferTemplateFormSchema.parse(payload)),
      ),
    onSuccess: async (_result, _variables, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: offerTemplateKeys.detail(id)}),
        client.invalidateQueries({queryKey: offerTemplateKeys.lists()}),
      ]);
    },
  });
}
